import React from 'react';

import { Props as LinkProps } from 'Elements/Link';

import { Container, Label, StyledLink } from '../InformationBlocks.styled';

export interface Props {
    discount: string;
    link: LinkProps;
}

const AlumniDiscount: React.FC<Props> = props => {
    const { discount, link } = props;

    return (
        <Container>
            <Label>
                Up to: <strong>{discount} alumni discount</strong>
            </Label>
            <StyledLink {...link} openInNewTab />
        </Container>
    );
};

export default AlumniDiscount;
